import { useEffect, useState } from "react"

import Button from "../Button/Button"
import Advice from "../Advice/Advice"
import withSpinner from "../withSpinner/withSpinner"


import { fetchRandomAdvice } from "../../helpers/fetchData"


import "./Modal.scss"

const Modal = () => {
    const [advice, setAdivce] = useState({})
    const [isLoading, setIsLoading] = useState(false)


    useEffect(() => {
        setIsLoading(true)
        const fetchData = async () => {
            const res = await fetchRandomAdvice()
            setAdivce(res.slip)
            setIsLoading(false)
        }
        fetchData()
    }, [])


    const onClickHandler = async () => {
        setIsLoading(true)
        const res = await fetchRandomAdvice()
        setAdivce(res.slip)
        setIsLoading(false)
    }


    const AdviceWithSpinner = withSpinner(Advice)

    return (
        <div className="container">
            <div className="modal">
                <AdviceWithSpinner isLoading={isLoading} advice={advice} />
                <Button onClick={onClickHandler} />
            </div>
        </div >
    )
}

export default Modal